//仅适用于vue环境无react的情况，react环境请在tnsSdk.js引入之前将react.js/react-dom.js进行引入。
// if(!window.React){
//     window.React = {TNS:true,__tips:"tns降级react对象"};
//     window.React.Component = ()=>{};
//     window.React.PureComponent = ()=>{};
//     window.React.createContext = function(){return {}};
//     window.React.createElement = function(){return {}};
//     console.log('[TNE]检查当前环境无React自动降级完成');
// }


class ReactShim {}
if(!window.React){
    ReactShim = {TNS:true,__tips:"tns降级react对象"};
    ReactShim.Component = ()=>{};
    ReactShim.PureComponent = ()=>{};
    ReactShim.createContext = function(){return {}};
    ReactShim.createElement = function(){return {}};
    ReactShim.forwardRef = function(){return {}};
    console.log('%c[TNE]检查当前环境无React自动降级完成，解决办法：将html引入的tnsSdk.js顺序放在react.js之后。', 'background: #000; color: #fff;font-size: 20px;');
} else {
    ReactShim = window.React
}

export default ReactShim
